// API Configuration - LOCAL BACKEND (PRODUCTION URL REMOVED FOR SAFETY)
// ORIGINAL PRODUCTION URL (DO NOT USE): https://backend-production-9659.up.railway.app
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Debug logging
console.log('=== API CONFIG DEBUG ===');
console.log('API_BASE_URL:', API_BASE_URL);
console.log('window.location:', window.location.href);
console.log('process.env.REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
console.log('========================');
